import { Container } from '@material-ui/core';
import { useAccount } from 'modules/account/hooks/useAccount';
import { t } from 'modules/i18n/utils/intl';
import { Button } from 'modules/uiKit/Button';
import { Wallet } from '../Wallet';
import { useHeaderStyles } from './HeaderStyles';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { useHeaderLinksStyles } from '../HeaderLinks/HeaderLinksStyles';
import {
  SelectChainDialog,
  useDialogState,
} from 'modules/layout/components/Header/components/SelectChainDialog';
import { DynamicBitcoinRoutesConfig } from 'modules/dynamicBitcoin/Routes';
import { DocsRoutesConfig } from 'modules/docs/Routes';
import { IndexRoutesConfig } from 'modules/index/Routes';
import { Link } from 'react-router-dom';
import { HeaderNavationDrawer } from './components/HeaderNavationDrawer';
import { useIsLGDown } from 'modules/themes/useTheme';
import LogoIcon from './assets/logo.svg';

// import ConnectIcon from './assets/connectIcon.svg';

const lindSpaceStyles = { marginLeft: 16 };

export const Header = () => {
  const { isConnected, handleConnect, loading, chainId } = useAccount();
  const classes = useHeaderStyles();
  const linksClasses = useHeaderLinksStyles();
  const renderedWallet = <Wallet />;
  const { opened: openedSelectChainDialog, close: closeSelectChainDialog } =
    useDialogState();

  const isMobile = useIsLGDown();

  const renderedDesktop = (
    <Box className={classes.userBox}>
      {!isConnected && (
        <Box display={'flex'} alignItems={'center'}>
          {/* <img src={ConnectIcon} className={classes.connectIcon} alt="" /> */}
          <Button
            onClick={handleConnect}
            className={classNames(classes.connect)}
            loading={loading}
          >
            {isMobile ? t('header.h5connect') : t('header.connect')}
          </Button>
        </Box>
      )}
      {isConnected && <div>{renderedWallet}</div>}
    </Box>
  );

  return (
    <header className={classNames(classes.root)}>
      <Container className={classes.container} maxWidth={false}>
        <SelectChainDialog
          isOpen={openedSelectChainDialog}
          onClose={closeSelectChainDialog}
          currentChain={chainId}
        />
        {!isMobile ? (
          <Box className={classes.navs}>
            <Link
              to={IndexRoutesConfig.Index.path}
              className={classes.logoLink}
            >
              <img
                alt="DFDunk"
                className={classNames(classes.img, classes.ableDark)}
                src={LogoIcon}
              />
            </Link>
            <Box ml={5} display={'flex'} alignItems={'center'}>
              <Button
                component={NavLink}
                variant="text"
                style={lindSpaceStyles}
                activeClassName={linksClasses.activeLink}
                className={linksClasses.link}
                to={DynamicBitcoinRoutesConfig.Index.path}
              >
                GENE
              </Button>
              <Button
                component={NavLink}
                variant="text"
                style={lindSpaceStyles}
                activeClassName={linksClasses.activeLink}
                className={linksClasses.link}
                to={DocsRoutesConfig.Index.path}
              >
                DOCS
              </Button>
            </Box>
          </Box>
        ) : (
          <Box>
            <Link
              to={IndexRoutesConfig.Index.path}
              className={classes.logoLink}
            >
              <img
                alt="DFDunk"
                className={classNames(classes.img, classes.ableDark)}
                src={LogoIcon}
              />
            </Link>
          </Box>
        )}
        <Box display={'flex'} alignItems={'center'}>
          {renderedDesktop}
          <HeaderNavationDrawer />
        </Box>
      </Container>
    </header>
  );
};
